export default __webpack_public_path__ + "static/media/product-18.9728f8bb.jpg";